import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { ProcessOption } from 'data/processOption/processOption.types';
// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  processOptionData: ProcessOption,
  originalProcessOptionFormData: ProcessOption | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.PROCESS_OPTIONS_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.PROCESS_OPTIONS_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(processOptionData, null, isEdit, originalProcessOptionFormData),
    processOptionData.PROCNAME,
    AuditService.PROCESS_OPTIONS,
    actionType,
  );
  return auditDetails as AuditDetails;
}
